import type { HttpClient } from '../http';
import { unwrap, type ApiEnvelope } from '../envelope';
import type { PlatformOrg, ActivationSummary, SetTierRequest, PlatformUpgradeRequest, ProcessUpgradeRequest } from '../types/domain';

export function platformEndpoints(http: HttpClient) {
  return {
    orgs: () => http.get<ApiEnvelope<PlatformOrg[]>>('/v1/platform/orgs').then(unwrap),
    activationSummary: () => http.get<ApiEnvelope<ActivationSummary>>('/v1/platform/activation-summary').then(unwrap),
    setTier: (id: string, body: SetTierRequest) => http.put<ApiEnvelope<{ id: string; tier: string; pilotUntil?: string | null }>>(`/v1/platform/orgs/${id}/tier`, body).then(unwrap),
    upgradeRequests: (status?: string) => http.get<ApiEnvelope<PlatformUpgradeRequest[]>>('/v1/platform/upgrade-requests', { query: { status } }).then(unwrap),
    processUpgrade: (id: string, body: ProcessUpgradeRequest) => http.post<ApiEnvelope<{ id: string; status: string; orgTier?: string }>>(`/v1/platform/upgrade-requests/${id}/process`, body).then(unwrap),
  };
}
export type PlatformEndpoints = ReturnType<typeof platformEndpoints>;
